import { render, staticRenderFns } from "./GerenciamentoServicoListFiltroModalItemInputCliente.vue?vue&type=template&id=2711aa44"
import script from "./GerenciamentoServicoListFiltroModalItemInputCliente.vue?vue&type=script&lang=js"
export * from "./GerenciamentoServicoListFiltroModalItemInputCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports